var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendToken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "white",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 19.6875,
    fill: "#00C05B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2179 16.5808C30.6229 15.4605 29.5373 14.3749 28.417 14.7808L14.7248 19.7327C13.6008 20.1396 13.4648 21.6733 14.4989 22.2724L18.8695 24.8027L22.7723 20.8999C22.9491 20.7291 23.1859 20.6346 23.4318 20.6367C23.6776 20.6389 23.9127 20.7375 24.0865 20.9113C24.2603 21.0851 24.3589 21.3202 24.3611 21.566C24.3632 21.8119 24.2687 22.0487 24.0979 22.2255L20.1951 26.1283L22.7264 30.4989C23.3245 31.533 24.8583 31.3961 25.2651 30.273L30.2179 16.5808Z",
    fill: "#F6FAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendToken);
export default __webpack_public_path__ + "static/media/SendToken.5255e5c1a74daec588300c393dc1c189.svg";
export { ForwardRef as ReactComponent };